module.exports = __webpack_public_path__ + "static/media/ht.bcc00e86.svg";